import { render, staticRenderFns } from "./addBox.vue?vue&type=template&id=5b32d33a&scoped=true"
import script from "./addBox.vue?vue&type=script&lang=js"
export * from "./addBox.vue?vue&type=script&lang=js"
import style0 from "./addBox.vue?vue&type=style&index=0&id=5b32d33a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b32d33a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b32d33a')) {
      api.createRecord('5b32d33a', component.options)
    } else {
      api.reload('5b32d33a', component.options)
    }
    module.hot.accept("./addBox.vue?vue&type=template&id=5b32d33a&scoped=true", function () {
      api.rerender('5b32d33a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/daily/components/addBox.vue"
export default component.exports